import { sleep } from './sleep'

export const createRace = <T>(promise: Promise<T>, ms: number): Promise<T | void> => Promise.race([promise, sleep(ms)])
